import script from "./MainView.vue?vue&type=script&setup=true&lang=js"
export * from "./MainView.vue?vue&type=script&setup=true&lang=js"

import "./MainView.vue?vue&type=style&index=0&id=1ebff08a&lang=css"

const __exports__ = script;

export default __exports__